import {
  sendUserComEvent,
  USER_COM_EVENT,
  USER_COM_TYPE,
} from '../api';

export const userComLoginEvent = () =>  sendUserComEvent({type: USER_COM_TYPE.EVENT, data: { event_name: USER_COM_EVENT.LOGIN, payload: {} }});

